import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { SubentityState } from 'app/projects/subentity/src/lib/models/subentity.state';
import {
    CreateCourseStructureCategorySuccess,
    DeselectSelectedCourseStructureCategories,
    SelectFilteredCourseStructureCategories,
    SetCourseStructureCategories,
    ToggleSelectedCourseStructureCategory,
} from '../actions';
import { AddCourseStructureCategories } from '../actions/add-entities.action';
import { CourseOfferingsCategoriesStateModel as CourseStructureCategoriesStateModel } from './course-structure-categories.state-model';
import { CourseStructureCategory } from './course-structure-category.model';
import { CourseStructureCategoryState } from './course-structure-category.state';

@State<CourseStructureCategoriesStateModel>({
    name: 'courseStructureCategories',
    defaults: new CourseStructureCategoriesStateModel(),
})
@Injectable()
export class CourseStructureCategoriesState extends SubentityState<CourseStructureCategory> {
    @Selector([CourseStructureCategoryState.getEntities])
    static getFilteredEntities(state: CourseStructureCategoriesStateModel, courseOfferingsCategories: CourseStructureCategory[]): CourseStructureCategory[] {
        if (!courseOfferingsCategories) {
            return null;
        }

        return courseOfferingsCategories
            .filter((item) => state.filtered.indexOf(item.id) !== -1)
            .map((item) => {
                return [state.list.indexOf(item.id), item];
            })
            .sort((a: [number, CourseStructureCategory], b: [number, CourseStructureCategory]) => {
                return a[0] > b[0] ? 1 : b[0] > a[0] ? -1 : 0;
            })
            .map((x: [number, CourseStructureCategory]) => x[1]);
    }

    @Selector()
    static getSelectedEntityIds(state: CourseStructureCategoriesStateModel): string[] {
        return state.selected;
    }

    @Selector()
    static getSearchTerm(state: CourseStructureCategoriesStateModel): string {
        return state.searchTerm;
    }

    @Selector()
    static isFetchingList(state: CourseStructureCategoriesStateModel): boolean {
        return state.fetchingList;
    }

    constructor(private store: Store) {
        super(null, 0);
    }

    @Action(AddCourseStructureCategories)
    addEntities(ctx: StateContext<CourseStructureCategoriesStateModel>, action: AddCourseStructureCategories): void {
        const courseOfferingsCategories = this.store.selectSnapshot(CourseStructureCategoryState.getEntities) || [];

        this._patchSubentities(ctx, { payload: { subentityIds: action.payload.map((entity) => entity.id) } }, courseOfferingsCategories);
    }

    @Action(CreateCourseStructureCategorySuccess)
    createEntity(ctx: StateContext<CourseStructureCategoriesStateModel>, action: CreateCourseStructureCategorySuccess): void {
        const courseOfferingsCategories = this.store.selectSnapshot(CourseStructureCategoryState.getEntities) || [];

        this._patchSubentities(ctx, { payload: { subentityIds: [action.payload.id] } }, courseOfferingsCategories);
    }

    @Action(SetCourseStructureCategories)
    setEntities(ctx: StateContext<CourseStructureCategoriesStateModel>, action: SetCourseStructureCategories): void {
        this._setSubentities(ctx, action, null);
    }

    @Action(ToggleSelectedCourseStructureCategory)
    toggleSelect(ctx: StateContext<CourseStructureCategoriesStateModel>, action: ToggleSelectedCourseStructureCategory): void {
        this._toggleSelectedSubentity(ctx, action);
    }

    @Action(SelectFilteredCourseStructureCategories)
    selectAll(ctx: StateContext<CourseStructureCategoriesStateModel>): void {
        this._selectFilteredSubentities(ctx);
    }

    @Action(DeselectSelectedCourseStructureCategories)
    deselectAll(ctx: StateContext<CourseStructureCategoriesStateModel>): void {
        this._deselectSelectedSubentities(ctx);
    }
}
